import { DESKTOP_NAV } from "./navigation.ts";

export const DASHBOARD_SECTION_KEY = "horosho.dashboard.section.v1";
export const MARKETS_PERIOD_KEY = "horosho.markets.period.v1";

const DASHBOARD_SECTIONS = new Set<string>(DESKTOP_NAV.map((item) => item.id));
const MARKET_PERIODS = new Set(["1D", "1W", "1M", "3M", "6M"]);

type PreferenceStorage = Pick<Storage, "getItem" | "setItem">;

export function isDashboardSection(value: unknown): value is (typeof DESKTOP_NAV)[number]["id"] {
  return typeof value === "string" && DASHBOARD_SECTIONS.has(value);
}

export function isMarketPeriod(value: unknown): value is string {
  return typeof value === "string" && MARKET_PERIODS.has(value);
}

export function loadDashboardSection(storage: PreferenceStorage): string | null {
  try {
    const value = storage.getItem(DASHBOARD_SECTION_KEY);
    return isDashboardSection(value) ? value : null;
  } catch {
    return null;
  }
}

export function saveDashboardSection(storage: PreferenceStorage, value: string): boolean {
  if (!isDashboardSection(value)) return false;
  try {
    storage.setItem(DASHBOARD_SECTION_KEY, value);
    return true;
  } catch {
    return false;
  }
}

export function dashboardSectionToRestore(incomingHash: string, storedSection: unknown): string | null {
  if (incomingHash !== "") return null;
  return isDashboardSection(storedSection) ? storedSection : null;
}

export function loadMarketsPeriod(storage: PreferenceStorage, availablePeriods: readonly string[]): string | null {
  try {
    const value = storage.getItem(MARKETS_PERIOD_KEY);
    return isMarketPeriod(value) && availablePeriods.includes(value) ? value : null;
  } catch {
    return null;
  }
}

export function saveMarketsPeriod(
  storage: PreferenceStorage,
  value: string,
  availablePeriods: readonly string[]
): boolean {
  if (!isMarketPeriod(value) || !availablePeriods.includes(value)) return false;
  try {
    storage.setItem(MARKETS_PERIOD_KEY, value);
    return true;
  } catch {
    return false;
  }
}
